import React, { useState, useEffect } from 'react';
import { useNavigate, Routes, Route, NavLink } from 'react-router-dom';
import Documents from '../components/dashboard/Documents';
import ChatbotConfig from '../components/dashboard/ChatbotConfig';
import TestChatbot from '../components/dashboard/TestChatbot';
import Analytics from '../components/dashboard/Analytics';
import EmbedCode from '../components/dashboard/EmbedCode';
import Settings from '../components/dashboard/Settings';
import './Dashboard.css';

const Dashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    
    // Check if user has token and is authenticated
    if (!token || !isAuthenticated) {
      // Clear any stale data
      localStorage.removeItem('token');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('userName');
      localStorage.removeItem('userPlan');
      localStorage.removeItem('userId');
      navigate('/login');
      return;
    }
    
    setUser({
      email: localStorage.getItem('userEmail'),
      name: localStorage.getItem('userName') || 'User',
      plan: localStorage.getItem('userPlan') || 'basic'
    });
  }, [navigate]);

  const handleLogout = () => {
    // Clear all authentication data
    localStorage.removeItem('token');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userName');
    localStorage.removeItem('userPlan');
    localStorage.removeItem('userId');
    navigate('/login');
  };

  if (!user) return null;

  return (
    <div className="dashboard">
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="logo">
            <img src="/logo.png" alt="Figbot Logo" className="logo-icon" />
            <span className="logo-text">Figbot</span>
          </div>
        </div>
        <nav className="sidebar-nav">
          <NavLink to="/dashboard/documents" className="nav-item">
            <span className="nav-icon">📄</span>
            <span>Documents</span>
          </NavLink>
          <NavLink to="/dashboard/chatbot" className="nav-item">
            <span className="nav-icon">⚙️</span>
            <span>Chatbot Config</span>
          </NavLink>
          <NavLink to="/dashboard/test" className="nav-item">
            <span className="nav-icon">💬</span>
            <span>Test Chatbot</span>
          </NavLink>
          <NavLink to="/dashboard/embed" className="nav-item">
            <span className="nav-icon">🔗</span>
            <span>Embed Code</span>
          </NavLink>
          <NavLink to="/dashboard/analytics" className="nav-item">
            <span className="nav-icon">📊</span>
            <span>Analytics</span>
          </NavLink>
          <NavLink to="/dashboard/settings" className="nav-item">
            <span className="nav-icon">⚙️</span>
            <span>Settings</span>
          </NavLink>
        </nav>
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{user.name.charAt(0).toUpperCase()}</div>
            <div className="user-details">
              <div className="user-name">{user.name}</div>
              <div className="user-plan">{user.plan.toUpperCase()} Plan</div>
            </div>
          </div>
          <button onClick={handleLogout} className="logout-btn">Logout</button>
        </div>
      </aside>
      <main className="dashboard-main">
        <header className="dashboard-header">
          <h1>Dashboard</h1>
          <div className="header-actions">
            <span className="plan-badge">{user.plan.toUpperCase()}</span>
          </div>
        </header>
        <div className="dashboard-content">
          <Routes>
            <Route path="documents" element={<Documents />} />
            <Route path="chatbot" element={<ChatbotConfig />} />
            <Route path="test" element={<TestChatbot />} />
            <Route path="embed" element={<EmbedCode />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="settings" element={<Settings />} />
            <Route path="/" element={<Documents />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
